




















































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import moment from "moment";
import MyHistory from "./history.vue";
import MyDetail from "./detail.vue";

@Component({components:{MyHistory,MyDetail}})
export default class extends Mixins(MyList) {
  dispatchType = "investigate/items";

  hisModalVisible=false;

  formData:any={
    id:0,
    title:"",
    items:[],
  }

  columns: any[] = [
    { title: "名称", dataIndex: "title" },
    { title: "题型", scopedSlots: { customRender: "mode" } },
    { title: "发布", scopedSlots: { customRender: "url" } },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    this.loadData({
      pageSize: 10,
    });
  }

  showMyModal(data:any){
    this.formData=data;
    this.showEditModal(data.id||0);
  }

  addMyModal(){
    const data={
      id:0,
      title:"",
      items:[],
    }
    this.formData=data;
    this.showEditModal(data.id);
  }

  showHisModal(data:any){
    this.formData=data;
    this.hisModalVisible=true;
  }

  hideHisModal(){
    this.hisModalVisible=false;
  }

}
